
export enum toolType {
    InvalidTool = -1,
    Ruler = 1,
    DepthGuage=2,
    UT=3,
    Calipers=4,
    KeeperOrientation=5,
    DriveLugsEngaged=6,
    YESorNO=7,
    Observation=8,
    Eval=9,
    PassorFail=10,
    Template = 11,
    PitchGauge = 12,
    ConditionAssessment=13
}

export enum toolTypeYesNo {
    No = 0,
    Yes = 1
}

export enum toolTypePassFail {
    Fail = 0,
    Pass = 1
}

export enum componentTypes {
  Link = 230,
  Bushing = 231,
  Shoe = 232,
  Idler = 233,
  CarrierRoller = 234,
  TrackRoller = 235,
  Sprocket = 236,
  Guard = 237,
  TrackElongation = 240
}

export enum ScreenCode {
  ManageEquipment = 'ManageEquipment',
  Dashboard = 'Dashboard',
  Inspection = 'Inspection'
}

export enum ManageEquipmentColumn {
  CMU = 1,
  ResLife100 = 2,
  ResLife120 = 3,
  DOC = 4,
  ResDOC100 = 5,
  ResDOC120 = 6,
  Reading = 7,
  Worn0Percent = 8,
  Worn100Percent = 9,
  WorkOrder = 10,
  Brand = 11,
  BudgetLife = 12,
  BushTurned = 13,
  ProjectedLife100 = 14,
  ProjectedLife120 = 15,
  Difference = 16,
  PurchaseCost = 17,
  RepairCost = 18,
  InstallDate = 19,
  ActualWearRate = 21,
  BudgetWearRate = 20,
    ReplacementDate = 22
}

export enum PercentWornCalculationMethod {
  WorstWorn = 1,
  AverageComponents = 2
}

export enum ScreenCode {
  WC = 1,
  WF = 2,
  WI = 3,
  ME = 14,
  IP = 15,
}


export enum ConfigType {
  Fleet = 'Fleet_Report',
  Alert = 'Alerts_Report',
}

export enum DashBoardModule {
  UC = 1,
  GET = 2,
  DFI =3
}

export enum ModuleType {
  GET = 'GET',
  UC = 'UC',
  INVENTORY = 'INVENTORY'
}
